export function normalizeTemplates(list = [], localClones = {}) {
  return (Array.isArray(list) ? list : []).map((t, idx) => {
    let comps = t.components || {};
    
    // Parse comps if it is a string representation of components
    if (typeof comps === 'string') {
      try {
        comps = JSON.parse(comps);
      } catch (e) {
        comps = {};
      }
    }

    // Normalize components if it is an array (Meta native format)
    if (Array.isArray(comps)) {
      const mappedComps = {};
      comps.forEach(c => {
        if (c.type) {
          mappedComps[c.type] = c;
        }
      });
      comps = mappedComps;
    }

    let bodyText = '';
    try {
      if (comps.BODY) {
        const parsed = typeof comps.BODY === 'string' ? JSON.parse(comps.BODY) : comps.BODY;
        bodyText = parsed.text || parsed.body || '';
      }
    } catch (e) {
      bodyText = '';
    }

    let headerText = '';
    try {
      if (comps.HEADER) {
        const parsed = typeof comps.HEADER === 'string' ? JSON.parse(comps.HEADER) : comps.HEADER;
        headerText = parsed.text || '';
      }
    } catch (e) {
      headerText = '';
    }

    // Check if we have a locally stored template layout (from library clone cache)
    if (!bodyText) {
      try {
        const templateName = t.name || t.template_name || t.templateName;
        const localClonedRaw = localClones[`template_library_cloned_${templateName}`];
        if (localClonedRaw) {
          const localCloned = JSON.parse(localClonedRaw);
          if (localCloned) {
            bodyText = localCloned.body || '';
            headerText = localCloned.headerText || '';
            
            // Build comps from local definition
            let localComps = localCloned.components || {};
            if (typeof localComps === 'string') {
              try { localComps = JSON.parse(localComps); } catch (e) {}
            }
            if (Array.isArray(localComps)) {
              const mapped = {};
              localComps.forEach(c => { if (c.type) mapped[c.type] = c; });
              localComps = mapped;
            }
            comps = { ...localComps, ...comps };
          }
        }
      } catch (e) {
        // ignore
      }
    }

    // Secondary fallback to top level fields returned by backend
    if (!bodyText) {
      bodyText = t.body || t.bodyText || t.text || '';
    }
    if (!headerText) {
      headerText = t.headerText || t.header || '';
    }

    return {
      id: t.wabaTemplateId || t.id || `template_${idx + 1}`,
      name: t.name || t.template_name || t.templateName || '',
      description: t.description || '',
      body: bodyText,
      headerText,
      category: t.category || t.subCategory || '',
      status: t.status || '',
      language: t.language || 'en',
      isActive: !!t.isActive,
      createdAt: t.createdAt || null,
      updatedAt: t.updatedAt || null,
      components: comps
    };
  });
}
